module.exports = __webpack_public_path__ + "img/htgl1.32a55c0a.png";